export enum TutorialsGetters {
    GET_VIEW = 'GET_VIEW',
}
